export function downloadFile(href: string, filename: string): void {
  const link = document.createElement('a'); link.href = href; link.download = filename;
  document.body.appendChild(link); link.click(); link.remove();
}